import React from "react";
import { Link } from "react-router-dom";

export default function WorkspaceCreated() {
  const tenantSlug =
    new URLSearchParams(window.location.search).get("workspace") ||
    localStorage.getItem("x-tenant") ||
    "your workspace";

  const colors = {
    navy: "#071827",
    panel: "#13293d",
    border: "rgba(255,255,255,0.09)",
    gold: "#e0b84f",
    blue: "#00c2ff",
    text: "#ffffff",
    muted: "#9fb0c3",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(0,194,255,0.16), transparent 34%), linear-gradient(135deg, #071827 0%, #0b1b2b 45%, #10263a 100%)",
        color: colors.text,
        padding: 24,
        boxSizing: "border-box",
        display: "grid",
        placeItems: "center",
      }}
    >
      <section
        style={{
          maxWidth: 720,
          width: "100%",
          background: colors.panel,
          border: `1px solid ${colors.border}`,
          borderRadius: 24,
          padding: 34,
          boxShadow: "0 24px 80px rgba(0,0,0,0.28)",
        }}
      >
        <div style={{ color: colors.gold, fontWeight: 900, fontSize: 13, textTransform: "uppercase", letterSpacing: 1.2 }}>
          Workspace Created
        </div>

        <h1 style={{ fontSize: 40, lineHeight: 1.08, margin: "14px 0 12px" }}>
          Your JobTelesis workspace is ready.
        </h1>

        <p style={{ color: "#c9d8e8", fontSize: 16, lineHeight: 1.6 }}>
          Your workspace has been created successfully. Use your workspace name to sign back in and begin setting up your operational workflow.
        </p>

        <div
          style={{
            marginTop: 20,
            padding: 16,
            borderRadius: 16,
            background: "#071827",
            border: `1px solid ${colors.border}`,
          }}
        >
          <div style={{ color: colors.muted, fontSize: 13, marginBottom: 4 }}>
            Workspace name
          </div>
          <div style={{ fontSize: 24, fontWeight: 900, color: colors.gold }}>
            {tenantSlug}
          </div>
        </div>

        <div style={{ marginTop: 22, display: "grid", gap: 10 }}>
          {[
            "Sign into your workspace",
            "Create your first client",
            "Create your first job",
            "Generate your first estimate",
            "Start tracking revenue through invoices and payments",
          ].map((item) => (
            <div key={item} style={{ color: "#d7e7f5", fontSize: 15 }}>
              ✓ {item}
            </div>
          ))}
        </div>

        <Link
          to="/login"
          style={{
            display: "inline-block",
            marginTop: 28,
            background: colors.gold,
            color: colors.navy,
            textDecoration: "none",
            fontWeight: 900,
            padding: "13px 18px",
            borderRadius: 12,
          }}
        >
          Continue to Login
        </Link>
      </section>
    </div>
  );
}
